import React from 'react';
import Link from 'next/link';
import mapImage from '../../assets/img/map/map.png';

const MapSection = ({ title, subtitle }) => {
  return (
    <section className="usa-map-section">
      <div className="usa-map-header">
        <h2 className="usa-map-title">
          {title || (
            <>
              <span className="text-primary">Delivering Scan to BIM Excellence</span> Across the USA
            </>
          )}
        </h2>
        <p className="usa-map-subtitle">
          {subtitle || "We proudly offer Scan to BIM services across major US locations, including: New York, California, Texas, Florida, Chicago, New Jersey, Pennsylvania, and more."}
        </p>
      </div>

      <div className="usa-map-content">
        <div className="usa-map-image-col">
          <img
            src={mapImage.src || mapImage}
            alt="USA Map"
            className="usa-map-image"
          />
        </div>

        <div className="usa-map-list-col">
          <div className="usa-map-column">
            {[
              "California",
              "Texas",
              "Florida",
              "New York",
              "Pennsylvania",
              "Illinois",
              "Georgia",
              "North Carolina",
              "New Jersey",
            ].map((state) => (
              <Link
                key={state}
                href={state === "California" ? "/service/bimservice/scan-to-bim-services-california" : "#!"}
                className="usa-map-item"
              >
                <div className="item-check">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                {state}
              </Link>
            ))}
          </div>
          <div className="usa-map-column">
            {[
              "Washington",
              "Massachusetts",
              "Arizona",
              "Colorado",
              "Ohio",
              "Michigan",
              "Tennessee",
              "Indiana",
              "Missouri",
            ].map((state) => (
              <Link key={state} href="#!" className="usa-map-item">
                <div className="item-check">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                {state}
              </Link>
            ))}
          </div>
          <div className="usa-map-column">
            {[
              "Maryland",
              "South Carolina",
              "Alabama",
              "Kentucky",
              "Nevada",
              "Virginia",
            ].map((state) => (
              <Link key={state} href="#!" className="usa-map-item">
                <div className="item-check">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                {state}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
